import React from "react";
import LegalDoc from "@/components/LegalDoc";
import { TERMS, TERMS_META } from "@/content/termsContent";

export default function TermsPage() {
  return <LegalDoc meta={TERMS_META} blocks={TERMS} />;
}
